import React from "react";
import { DateTime } from "luxon";

export default function ReadOnlyEmailViewer({ email }) {
  if (!email) return null;

  const formatGraphTime = (dateTimeStr, timeZoneStr = "UTC") => {
    try {
      const dt = DateTime.fromISO(dateTimeStr, { zone: timeZoneStr });
      return dt.toLocal().toLocaleString(DateTime.DATETIME_MED);
    } catch {
      return "Invalid date";
    }
  };

  return (
    <div className="p-4 bg-white space-y-4">
      {/* Subject */}
      <h3 className="text-xl font-semibold text-gray-800">{email.subject}</h3>

      {/* Sender and recipient info */}
      <div className="flex items-start gap-4">
        <div className="w-10 h-10 bg-gray-300 text-black flex items-center justify-center rounded-full text-lg font-semibold">
          {email.from?.emailAddress?.name?.[0] || "?"}
        </div>
        <div>
          <div className="text-sm font-medium text-gray-800">{email.from?.emailAddress?.name}</div>
          <div className="text-xs text-gray-500">{email.from?.emailAddress?.address}</div>
          <div className="text-xs text-gray-700">
            <span className="font-medium">To: </span>
            {email.toRecipients?.map((r, i) => (
              <span key={i}>
                {r.emailAddress?.name}
                {i < email.toRecipients.length - 1 && ", "}
              </span>
            ))}
          </div>
        </div>
        <div className="ml-auto text-xs text-gray-500">
          {formatGraphTime(email.receivedDateTime || email.sentDateTime)}
        </div>
      </div>

      {/* Body */}
      <div
        className="prose max-w-none text-gray-700 mt-4"
        dangerouslySetInnerHTML={{ __html: email.body?.content || "<p>No content</p>" }}
      />

      {/* Attachments */}
      {email.hasAttachments && email.attachments?.length > 0 && (
        <div className="mt-6">
          <h4 className="text-sm font-semibold mb-2">Attachments:</h4>
          <ul className="space-y-2">
            {email.attachments.map((att, idx) => {
              const blobUrl = att.contentBytes
                ? URL.createObjectURL(
                    new Blob([Uint8Array.from(atob(att.contentBytes), (c) => c.charCodeAt(0))], {
                      type: att.contentType,
                    })
                  )
                : "#";

              return (
                <li key={idx} className="flex items-center gap-3 text-sm">
                  <i className="fa-solid fa-paperclip text-gray-500" />
                  <a href={blobUrl} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">
                    {att.name}
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </div>
  );
}